import { IndustryTemplate } from '@/components';
import { cleaningContent } from '@/data/industries/cleaning';

export function CleaningPage() {
  return <IndustryTemplate content={cleaningContent} />;
}
